import { ActionType, InvoiceActionType, RolesWithPermissions } from '../models/premissions.model';
import { UserType } from '../models/user';

export const rolesWithPermissions: RolesWithPermissions = {
    [UserType.SysAdmin]: {
        products: {
            [ActionType.Create]: true,
            [ActionType.Read]: true,
            [ActionType.Update]: true,
            [ActionType.Delete]: true,
        },
        users: {
            [ActionType.Create]: true,
            [ActionType.Read]: true,
            [ActionType.Update]: true,
            [ActionType.Delete]: true,
        },
        prices: {
            [ActionType.Create]: true,
            [ActionType.Read]: true,
            [ActionType.Update]: true,
            [ActionType.Delete]: true,
        },
        invoices: {
            [ActionType.Create]: true,
            [ActionType.Read]: true,
            [ActionType.Update]: true,
            [ActionType.Delete]: true,
            [InvoiceActionType.DebugInfo]: true,
            [InvoiceActionType.ExtendedPriceinfo]: true,
        },
        timeRegistration: {
            [ActionType.Create]: true,
            [ActionType.Read]: true,
            [ActionType.Update]: true,
            [ActionType.Delete]: true,
        },
        admin: {
            [ActionType.Create]: true,
            [ActionType.Read]: true,
            [ActionType.Update]: true,
            [ActionType.Delete]: true,
        }
    },
    [UserType.CustomerUser]: {
        products: {
            [ActionType.Create]: true,
            [ActionType.Read]: true,
            [ActionType.Update]: true,
            [ActionType.Delete]: true,
        },
        users: {
            [ActionType.Create]: true,
            [ActionType.Read]: true,
            [ActionType.Update]: true,
            [ActionType.Delete]: true,
        },
        prices: {
            [ActionType.Create]: true,
            [ActionType.Read]: true,
            [ActionType.Update]: true,
            [ActionType.Delete]: true,
        },
        invoices: {
            [ActionType.Create]: true,
            [ActionType.Read]: true,
            [ActionType.Update]: true,
            [ActionType.Delete]: true,
            [InvoiceActionType.ExtendedPriceinfo]: true,
        },
        timeRegistration: {
            [ActionType.Create]: true,
            [ActionType.Read]: true,
            [ActionType.Update]: true,
            [ActionType.Delete]: true,
        },
    },
    [UserType.ProductUpdator]: {
    },
    [UserType.TimeReportingUser]: {
    },
    [UserType.PunchClockUser]: {
    },
    [UserType.DeveloperUser]: {
    },
    [UserType.ApiIntegrationUser]: {
    }
};
